import React, { PureComponent } from 'react';
import { Chip, Avatar } from '@material-ui/core';
import { Check } from '@material-ui/icons';
import './chipCheckbox.scss';

export class ChipCheckbox extends PureComponent {
  constructor() {
    super();
    this.state = {
      selected: false,
    };
  }

  // onDelete = () => {
  //   const { onDeleteChip, label } = this.props;
  //   onDeleteChip(label);
  // };

  // onHover = selected => () => {
  //   this.setState({
  //     selected
  //   });
  // };

  onClick = () => {
    const { onClick, label } = this.props;
    this.setState({ selected: !this.state.selected });
    onClick(label, this.state.selected);
  };

  render() {
    const { selected } = this.state;
    const { label, onClick, classes } = this.props;
    const clickable = Boolean(onClick) ? { onClick: this.onClick } : {};

    return (
      <Chip
        avatar={
          selected ? (
            <Avatar
              style={{
                backgroundColor: '#BDD3C9',
                width: '25px',
                height: '25px',
                margin: '3px',
              }}
            >
              <Check></Check>
            </Avatar>
          ) : null
        }
        label={label}
        className={`chip${
          this.state.selected
            ? ' chip-selected chip-checkbox '
            : ' chip-checkbox '
        } ${classes}`}
        color={this.state.selected ? 'primary' : 'default'}
        {...clickable}
      />
    );
  }
}

ChipCheckbox.defaultProps = {
  classes: '',
  onDeleteChip: false,
  onClick: false,
};
